var d = "/static/fcc340b7d15e764b.png";

export { d as default };
//# sourceMappingURL=instant_rakeback.png.js.map
